import React from 'react';
import { IProps } from './interfaces';

const KrCheckin: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M16,31.89C7.24,31.89.11,24.76.11,16S7.24.11,16,.11c.5,0,.9.4.9.9s-.4.9-.9.9C8.23,1.91,1.91,8.23,1.91,16s6.32,14.09,14.09,14.09,14.09-6.32,14.09-14.09c0-.5.4-.9.9-.9s.9.4.9.9c0,8.76-7.13,15.89-15.89,15.89Z"
      />
      <path
        fill={color}
        d="M15.04,21.5l-6.31-6.31c-.23-.23-.23-.61,0-.85s.61-.23.85,0l5.47,5.47,14.03-14.03c.23-.23.61-.23.85,0s.23.61,0,.85l-14.88,14.88Z"
      />
    </svg>
  );
};

export default KrCheckin;
